var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotifiBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1166 12.075L15.2833 10.6916C15.1083 10.3833 14.9499 9.79996 14.9499 9.45829V7.34996C14.9499 5.39163 13.7999 3.69996 12.1416 2.90829C11.7083 2.14163 10.9083 1.66663 9.99161 1.66663C9.08328 1.66663 8.26661 2.15829 7.83328 2.93329C6.20828 3.74163 5.08328 5.41663 5.08328 7.34996V9.45829C5.08328 9.79996 4.92495 10.3833 4.74995 10.6833L3.90828 12.075C3.57495 12.6333 3.49995 13.25 3.70828 13.8166C3.90828 14.375 4.38328 14.8083 4.99995 15.0166C6.61661 15.5666 8.31661 15.8333 10.0166 15.8333C11.7166 15.8333 13.4166 15.5666 15.0333 15.025C15.6166 14.8333 16.0666 14.3916 16.2833 13.8166C16.4999 13.2416 16.4416 12.6083 16.1166 12.075Z",
    fill: "var(--title-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3584 16.675C12.0084 17.6416 11.0834 18.3333 10 18.3333C9.34171 18.3333 8.69171 18.0666 8.23337 17.5916C7.96671 17.3416 7.76671 17.0083 7.65004 16.6666C7.75837 16.6833 7.86671 16.6916 7.98337 16.7083C8.17504 16.7333 8.37504 16.7583 8.57504 16.775C9.05004 16.8166 9.53337 16.8416 10.0167 16.8416C10.4917 16.8416 10.9667 16.8166 11.4334 16.775C11.6084 16.7583 11.7834 16.75 11.95 16.725C12.0834 16.7083 12.2167 16.6916 12.3584 16.675Z",
    fill: "var(--title-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotifiBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notifi-blue.6ea28f86.svg";
export { ForwardRef as ReactComponent };